import DeleteResumeSkillModal from './DeleteResumeSkillModal'

export default DeleteResumeSkillModal
